<template>
  <div class="daily-card">
    <h4 class="pb-2">
      Daily Site Overview
    </h4>
    <div class="stats-container">
      <div class="stat-box checked-in">
        <p class="label pb-2">
          Checked-In
        </p>
        <p class="count">
          {{ dailyReports.total_workers_present || '0' }}
        </p>
      </div>

      <div class="stat-box not-in">
        <p class="label pb-2">
          Not In
        </p>
        <p class="count">
          {{ dailyReports.absentees || '0' }}
        </p>
      </div>

      <div class="stat-box active-projects">
        <p class="label">
          Active Projects
        </p>
        <p class="count">
          {{ dailyReports.projects || '0'}}
        </p>
      </div>
      <div
        class="stat-box"
        @click="goToReport"
      >
        <v-icon color="#000">
          mdi-arrow-top-right
        </v-icon>
        <p class="label">
          View Report
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DailySiteOverview',
  props: {
  },
  computed: {
    dailyReports () {
      return this.$store.getters['organization/getDailyReports'];
    },
  },
  methods: {
    goToReport () {
      this.$router.push({ name: 'Reports' });
    },
  },
};
</script>

<style scoped>
.daily-card {
  background: #ffffff;
  border-radius: 6px;
  padding: 16px;
  width: 100%;
}

.stats-container {
  display: flex;
  justify-content: space-between;
  gap: 5px;
}

.stat-box {
  width: 100%;
  padding: 5px 2px;
  border-radius: 10px;
  text-align: center;
  background: #fafafa;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}

.stat-box .count {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0px !important;
}

.label {
  font-size: 10px;
  color: #666;
  margin-bottom: 0px !important;
}

.checked-in {
  background-color: #2ecc703d;
  border: 1px solid #2ecc708e;
}
.not-in {
  background-color: #e74d3c48;
  border: 1px solid #e74d3c8f;
}
.active-projects {
  background-color: #3498db3b;
  border: 1px solid #3498db8f;
}
</style>
